import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { JsonEditorComponent } from '../../../../../../../utils/json-editor-component';

@Component({
  selector: 'app-json-cv',
  standalone: true,
  imports: [CommonModule, JsonEditorComponent],
  templateUrl: './json-cv.component.html',
  styleUrl: './json-cv.component.scss'
})
export class JsonCvComponent {

  constructor(
    public dialogRef: MatDialogRef<JsonCvComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  closeModal() {
    this.dialogRef.close();
  }

}
